import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SECCIONES = [
  { id: 'temario',         label: 'Temario',              icon: '📚' },
  { id: 'actividades',     label: 'Actividades/Exámenes', icon: '✏️' },
  { id: 'clases-online',   label: 'Clases Online',        icon: '🎥' },
  { id: 'clases-grabadas', label: 'Clases Grabadas',      icon: '🎬' },
  { id: 'calendario',      label: 'Calendario',           icon: '📅' },
  { id: 'hall-fama',       label: 'Hall de la Fama',      icon: '🏆' },
];

function NavContents({ tema, tipo, nivel, nivelesInfo, nivelesAccesibles, esProfesor, ir, location }) {
  return (
    <>
      {/* Nivel */}
      <div style={{ padding: '20px 16px', borderBottom: `1px solid ${tema.border}` }}>
        <p style={{ color: tema.muted, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>
          Nivel
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {nivelesInfo.lista.map((n, i) => {
            const activo = n === nivel;
            const accesible = nivelesAccesibles.includes(n);
            return (
              <button
                key={n}
                onClick={() => accesible && ir(`/${tipo}/${n}/temario`)}
                style={{
                  background: activo ? `${tema.accent}18` : 'transparent',
                  border: `1px solid ${activo ? tema.accent : 'transparent'}`,
                  color: activo ? tema.accent : accesible ? tema.text : tema.muted,
                  borderRadius: '8px', padding: '8px 12px', textAlign: 'left',
                  fontSize: '14px', fontWeight: activo ? 600 : 400,
                  cursor: accesible ? 'pointer' : 'not-allowed',
                  opacity: accesible ? 1 : 0.35, transition: 'all 0.15s',
                }}
              >
                {nivelesInfo.display[i]}
              </button>
            );
          })}
        </div>
      </div>

      {/* Secciones */}
      <div style={{ padding: '16px 12px', flex: 1 }}>
        <p style={{ color: tema.muted, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', paddingLeft: '4px' }}>
          Secciones
        </p>
        {SECCIONES.map(sec => {
          const ruta = `/${tipo}/${nivel}/${sec.id}`;
          const activo = location.pathname === ruta || location.pathname.startsWith(ruta + '/');
          return (
            <button
              key={sec.id}
              onClick={() => ir(ruta)}
              style={{
                width: '100%', background: activo ? `${tema.accent}14` : 'transparent',
                border: `1px solid ${activo ? tema.accent + '44' : 'transparent'}`,
                color: activo ? tema.accent : tema.text,
                borderRadius: '10px', padding: '10px 12px', textAlign: 'left',
                fontSize: '14px', fontWeight: activo ? 600 : 400,
                cursor: 'pointer', marginBottom: '2px',
                display: 'flex', alignItems: 'center', gap: '10px',
                transition: 'all 0.15s',
              }}
            >
              <span style={{ fontSize: '16px' }}>{sec.icon}</span>
              {sec.label}
            </button>
          );
        })}
      </div>

      {/* Aprendizaje */}
      {esProfesor && (
        <div style={{ padding: '0 12px 8px' }}>
          <button
            onClick={() => ir('/aprendizaje')}
            style={{
              width: '100%', background: `${tema.accent}10`,
              border: `1px solid ${tema.accent}33`,
              color: tema.accent, borderRadius: '10px', padding: '10px 12px',
              fontSize: '14px', fontWeight: 600, cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: '10px',
            }}
          >
            <span style={{ fontSize: '16px' }}>📊</span>
            Aprendizaje
          </button>
        </div>
      )}

      {/* Volver */}
      <div style={{ padding: '16px', borderTop: `1px solid ${tema.border}` }}>
        <button
          onClick={() => ir('/seleccion')}
          style={{
            width: '100%',
            background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
            border: 'none', color: '#fff', borderRadius: '50px', padding: '10px',
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(236,72,153,0.35)',
          }}
        >
          ← Volver al inicio
        </button>
      </div>
    </>
  );
}

export default function SidebarSeccion({ tema, tipo, nivel }) {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [abierto, setAbierto] = useState(false);
  const [esMobile, setEsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const check = () => setEsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => { setAbierto(false); }, [location.pathname]);

  const nivelesInfo = tipo === 'militar'
    ? {
        lista:   ['SLP2','SLP3','SLP4','ACCESO_SUBOFICIAL','ACCESO_OFICIAL','CURSO_SUBOFICIAL','CURSO_OFICIAL'],
        display: ['SLP 2','SLP 3','SLP 4','Acceso Sub.','Acceso Of.','Curso Sub.','Curso Of.'],
      }
    : { lista: ['B1','B2','C1','C2'], display: ['B1','B2','C1','C2'] };

  const esProfesor = ['profesor','admin'].includes(usuario?.rol);
  const nivelesAccesibles = esProfesor
    ? nivelesInfo.lista
    : (usuario?.accesos || []).filter(a => a.tipo === tipo).map(a => a.nivel);

  const ir = (ruta) => { setAbierto(false); navigate(ruta); };

  const asideBase = {
    background: tema.bgCard,
    display: 'flex', flexDirection: 'column',
  };

  /* ── MÓVIL ─────────────────────────────────────── */
  if (esMobile) {
    return (
      <>
        {/* Backdrop */}
        {abierto && (
          <div
            onClick={() => setAbierto(false)}
            style={{
              position: 'fixed', inset: 0, zIndex: 200,
              background: 'rgba(88,28,71,0.5)',
              backdropFilter: 'blur(2px)',
            }}
          />
        )}

        {/* Drawer lateral */}
        {abierto && (
          <div style={{
            position: 'fixed', left: 0, top: 60, bottom: 0, width: 270,
            zIndex: 250, overflowY: 'auto',
            ...asideBase,
            borderRight: `1px solid ${tema.border}`,
            boxShadow: '4px 0 24px rgba(88,28,71,0.2)',
            animation: 'slideIn 0.22s ease-out',
          }}>
            <NavContents
              tema={tema} tipo={tipo} nivel={nivel}
              nivelesInfo={nivelesInfo} nivelesAccesibles={nivelesAccesibles}
              esProfesor={esProfesor} ir={ir} location={location}
            />
          </div>
        )}

        {/* Botón hamburguesa */}
        <button
          onClick={() => setAbierto(v => !v)}
          style={{
            position: 'fixed', bottom: 24, right: 20, zIndex: 300,
            width: 52, height: 52, borderRadius: '50%',
            background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
            border: 'none', color: '#fff', fontSize: 22, cursor: 'pointer',
            boxShadow: '0 6px 24px rgba(236,72,153,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {abierto ? '✕' : '☰'}
        </button>
      </>
    );
  }

  /* ── DESKTOP ────────────────────────────────────── */
  return (
    <aside style={{
      ...asideBase,
      width: 240, minWidth: 240,
      borderRight: `1px solid ${tema.border}`,
      minHeight: 'calc(100vh - 60px)',
      boxShadow: '2px 0 12px rgba(236,72,153,0.05)',
    }}>
      <NavContents
        tema={tema} tipo={tipo} nivel={nivel}
        nivelesInfo={nivelesInfo} nivelesAccesibles={nivelesAccesibles}
        esProfesor={esProfesor} ir={ir} location={location}
      />
    </aside>
  );
}
